export default "__VITE_ASSET__BghdEBog__"